import type { IconProps } from "../types";

export const Sprout = ({
  size = 24,
  strokeWidth = 2,
  absoluteStrokeWidth,
  ...props
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="butt"
    strokeLinejoin="miter"
    {...props}
  >
    <path d="M14 9.536V7a4 4 0 0 1 4-4h2v2a4 4 0 0 1-4 4 4 4 0 0 0-4 4c0 2 1 3 1 5a5 5 0 0 1-1 3" />
    <path d="M4 9a5 5 0 0 1 8 4 5 5 0 0 1-8-4" />
    <path d="M5 21h14" />
  </svg>
);
